<template>
  <v-data-table :headers="headers" :items="orders" :items-per-page="15">
    <template
      v-slot:item.client="{item}"
    >{{item.user.account.name}} - {{item.user.firstname}} {{item.user.lastname}}</template>
    <template v-slot:item.status="{item}">
      <v-chip :color="getColor(item.status)" dark>{{item.status}}</v-chip>
    </template>
    <template v-slot:item.amount="{item}">{{formatAmount(item.amount)}}</template>
    <template v-slot:item.actions="{item}">
      <v-btn icon @click="view(item)">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data: () => ({
    headers: [
      { text: "Id", value: "id" },
      {
        text: "Date",
        align: "left",
        value: "orderDate"
      },
      { text: "Client", value: "client" },
      { text: "Référence", value: "ref" },
      { text: "Service", value: "service.name" },
      { text: "Status", value: "status" },
      { text: "Montant", value: "amount" },
      { text: "Actions", value: "actions", sortable: false }
    ]
  }),
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  methods: {
    view(order) {
      this.$router.push("/orders/view/" + order.id);
    },

    getColor(status) {
      if (status == "paid") {
        return "red";
      }
      return "green";
    },
    formatAmount(amount) {
      return amount + " CHF";
    }
  }
};
</script>

<style>
</style>